/**
 * 余额管理
 */
<template>
  <div class="balance-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>余额管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!--账单列表-->
    <div class="detail-card">
      <div class="detail-card__header">余额信息</div>
      <div class="detail-card__body">
        <div class="balance-stats">
          <div class="stat-item">
            <span class="stat-label">付款账户</span>
            <el-tooltip effect="dark" placement="top" :content="name || '-'">
              <span class="stat-value">{{ name || "-" }}</span>
            </el-tooltip>
          </div>
          <div class="stat-item">
            <span class="stat-label">可用余额</span>
            <span class="stat-value is-balance">{{ formatAmount(balance) }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">冻结金额</span>
            <span class="stat-value is-frozen">{{
              formatAmount(frozenAmount)
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <!--充值打款信息-->
    <div class="detail-card">
      <div class="detail-card__header">充值打款信息</div>
      <div class="detail-card__body">
        <div class="detail-grid">
          <div
            class="detail-item"
            v-for="item in receiptFields"
            :key="item.label"
          >
            <span class="detail-label">{{ item.label }}</span>
            <span class="detail-value" :title="item.value">{{ item.value }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="操作类型 :">
        <el-select
          size="small"
          v-model="formInline.operationType"
          placeholder="请选择"
        >
          <el-option
            v-for="(val, index) in status_list"
            :label="val.label"
            :value="val.value"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="交易时间 : ">
        <el-date-picker
          size="small"
          v-model="formInline.date"
          type="daterange"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">搜索</el-button>
        <el-button size="small" @click="reset()">清空</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button size="small" type="primary" @click="exportdata"
        >导出数据</el-button
      >
    </div>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      empty-text="暂无数据"
      style="width: 100%"
    >
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column
        fixed
        prop="operationTypeStr"
        label="操作类型"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="transactionAmount"
        label="交易金额"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.transactionAmount.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="balanceAfterTransaction"
        label="交易后金额"
        min-width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.balanceAfterTransaction.toFixed(2) }}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="operatorName" label="操作人" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="createdAt" label="交易时间" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="30%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="部门名称" prop="deptName">
          <el-input
            size="small"
            v-model="editForm.deptName"
            auto-complete="off"
            placeholder="请输入部门名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门代码" prop="deptNo">
          <el-input
            size="small"
            v-model="editForm.deptNo"
            auto-complete="off"
            placeholder="请输入部门代码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  receiptInfo,
  billsList,
  billexcel,
  downloadreceiptinfo,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      info: {},
      status_list: [
        {
          label: "加款",
          value: 1,
        },
        {
          label: "扣款",
          value: 2,
        },
        {
          label: "银行返款",
          value: 3,
        },
        {
          label: "退票",
          value: 4,
        },
        {
          label: "垫付资金",
          value: 5,
        },
        {
          label: "垫资还款",
          value: 6,
        },
        {
          label: "原路退款",
          value: 7,
        },
        {
          label: "退款",
          value: 8,
        },
        {
          label: "对公转账",
          value: 9,
        },
        {
          label: "个人退款",
          value: 10,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        date: [],
        positionId: "",
        positionName: "",
        positionState: "",
      },
      // rules表单验证
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
        varLable: "",
        varName: "",
        operationType: "",
        date: [],
        startDate: "",
        endDate: "",
      },
      balance: JSON.parse(localStorage.getItem("user_info")).balance,
      name: JSON.parse(localStorage.getItem("user_info")).merchantName,
      frozenAmount: JSON.parse(localStorage.getItem("user_info")).frozenAmount,
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
    this.getReceiptInfo();
  },
  computed: {
    receiptFields() {
      const info = this.info || {};
      const bankType =
        info.depositBank || info.bankType
          ? `${info.depositBank || "-"}/${info.bankType || "-"}`
          : "-";
      return [
        { label: "收款账户名称", value: this.displayText(info.accountName) },
        { label: "收款账号", value: this.displayText(info.accountNumber) },
        { label: "开户行", value: this.displayText(info.depositBank) },
        { label: "收款方联行号", value: this.displayText(info.bankBranchCode) },
        { label: "收款银行/行别", value: bankType },
        { label: "打款备注", value: this.displayText(info.remark) },
      ];
    },
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    displayText(value) {
      if (value === 0 || value === 0.0) return "0";
      if (value === null || value === undefined || value === "") return "-";
      return value;
    },
    formatAmount(value) {
      if (value === 0 || value === "0") return "0.00";
      if (value === null || value === undefined || value === "") return "-";
      const num = Number(value);
      return Number.isNaN(num) ? value : num.toFixed(2);
    },
    downloadinfo() {
      downloadreceiptinfo().then((res) => {
        if (res.msg == "success") {
          window.open(res.data.downloadUrl);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        varLable: "",
        varName: "",
        operationType: "",
        date: [],
        startDate: "",
        endDate: "",
      };
      this.getdata(this.formInline);
    },
    exportdata() {
      let params = {
        page: 1,
        pageSize: 99999999,
        varLable: this.formInline.varLable,
        varName: this.formInline.varName,
        operationType: this.formInline.operationType,
        startDate: this.formInline.date[0] || "",
        endDate: this.formInline.date[1] || "",
      };

      billexcel(params).then((res) => {
        if (res.msg == "success") {
          window.open(res.data.downloadUrl);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    getReceiptInfo(parameter) {
      receiptInfo(parameter)
        .then((res) => {
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.info = res.data;
            this.balance =
              this.info.balance !== undefined
                ? this.info.balance
                : JSON.parse(localStorage.getItem("user_info")).balance;

            this.frozenAmount =
              this.info.frozenAmount !== undefined
                ? this.info.frozenAmount
                : JSON.parse(localStorage.getItem("user_info")).frozenAmount;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 获取公司列表
    getdata(parameter) {
      parameter.startDate = parameter.date[0] || "";
      parameter.endDate = parameter.date[1] || "";

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      billsList(parameter)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            this.listData.map((item) => {
              if (item.recruitmentStateDesc == "上线") {
                item.status = true;
              } else {
                item.status = false;
              }
            });
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("菜单加载失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.deptId = row.deptId;
        this.editForm.deptName = row.deptName;
        this.editForm.deptNo = row.deptNo;
      } else {
        this.title = "添加";
        this.editForm.deptId = "";
        this.editForm.deptName = "";
        this.editForm.deptNo = "";
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          // deptSave(this.editForm)
          //   .then(res => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     if (res.success) {
          //       this.getdata(this.formInline)
          //       this.$message({
          //         type: 'success',
          //         message: '公司保存成功！'
          //       })
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     this.$message.error('公司保存失败，请稍后再试！')
          //   })
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // deptDelete(row.deptId)
          //   .then(res => {
          //     if (res.success) {
          //       this.$message({
          //         type: 'success',
          //         message: '公司已删除!'
          //       })
          //       this.getdata(this.formInline)
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.loading = false
          //     this.$message.error('公司删除失败，请稍后再试！')
          //   })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.balance-page {
  padding-bottom: 8px;
}
.user-search {
  margin-top: 16px;
  margin-bottom: 12px;
  padding: 16px 16px 6px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.detail-card {
  margin-top: 16px;
  background: #fff;
}
.detail-card__header {
  height: 52px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #272727;
  border-bottom: 1px solid #ebeef5;
}
.detail-card__body {
  padding: 20px 24px 24px;
}
.balance-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 32px;
}
.stat-item {
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.stat-label {
  margin-bottom: 8px;
  font-size: 13px;
  color: #909399;
  line-height: 1.4;
}
.stat-value {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 20px;
  font-weight: 400;
  color: #303133;
  line-height: 1.3;
}
.stat-value.is-balance {
  color: #067d62;
}
.stat-value.is-frozen {
  color: #f56c6c;
}
.detail-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 32px;
  row-gap: 14px;
}
.detail-item {
  display: flex;
  align-items: center;
  min-width: 0;
  font-size: 13px;
  line-height: 1.5;
}
.detail-label {
  flex-shrink: 0;
  width: 108px;
  color: #909399;
}
.detail-value {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #303133;
}
</style>

 


// WEBPACK FOOTER //
// src/views/payCenter/balanceManage.vue